
























import type { PropType } from '@vue/composition-api';
import { defineComponent, computed } from '@vue/composition-api';
import type { ColumnCount, Cell, MergeValues, EBlockWidth } from '@getaccept/editor-lib';
import { RowType } from '@getaccept/editor-lib';
import EditorCell from './EditorCell.vue';

export default defineComponent({
  name: 'EditorRowColumns',
  components: {
    EditorCell,
  },
  props: {
    columnCount: { type: Number as PropType<ColumnCount>, default: 3 },
    cells: { type: Array as PropType<Cell[]>, default: () => [] },
    mergeValues: {
      type: Object as PropType<MergeValues>,
      default: () => ({ document: {}, sender: {}, recipients: [], entity: {} }),
    },
    blockWidthClass: {
      type: String as PropType<EBlockWidth>,
      default: null,
    },
    pageWidth: { type: Number, default: 0 },
    isBlockToggled: { type: Boolean },
  },
  setup(props) {
    const cellWidth = computed(() => 100 / props.columnCount);

    const isParentFirstChild = (index: number) => index === 0;

    const isParentLastChild = (index: number) => index === props.cells.length - 1;

    return { RowType, cellWidth, isParentFirstChild, isParentLastChild };
  },
});
